<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn save_btn" @click.stop="onSubSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">生产订单出库</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="this.$store.state.cache.ProdOrderOutList"
        :noFromData="noFromData"
      ></v-head>
    </div>

    <div class="coll list_content">
      <el-tabs v-model="activeName2" type="border-card">
        <el-tab-pane label="数据明细" name="first">
            <v-list :fromData="this.$store.state.cache.ProdOrderOutList" :noFromData="noFromData" ref="vList"></v-list>
        </el-tab-pane>
        <el-tab-pane label="部件明细" name="second">
            <v-bom-list :bomDetail="this.$store.state.cache.ProdOrderOutList" :noFromData="noFromData" ref="bomList"></v-bom-list>
        </el-tab-pane>
      </el-tabs>
    </div>
    
  </div>
</template>

<script>
import { factoryApi} from "api/base.js";
import {productOrder,prodOrderInput} from "api/business.js";
import { company } from "api/system.js";
import vHead from "./components/ProdOrderCheckoutPanel/head.vue";
import VBomList from "./components/ProdOrderCheckoutPanel/bomList.vue";
import vList from "./components/ProdOrderCheckoutPanel/list.vue";


import { mapState, mapActions } from "vuex";
export default {
  components: {
    vHead,
    VBomList,
    vList
  },
  data() {
    return {
      activeName2: 'first',
      textarea: "",
      isLoading: true,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        orderStates:'0001',
        productOrderNo:'',
        scrapQuantity:0,
        
        bomDto:{
         
        },
        details: []
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    fromData: function(val, old) {
      console.log(val, old);
    }
  },
  created() {
    //请求初始数据
    this.getStartData();
    // let id = this.$route.params.id;
    // console.log(id)
  },
  methods: {
      
    ...mapActions("cache", ["clearCache"]),
    //关闭弹窗
    handleClose() {},
    //需要请求的初始数据
    getStartData() {
      //初始化数据
      // if(this.$store.state.cache.ProdOrderOutList.productOrderNo){
      //     this.fromData = this.$store.state.cache.ProdOrderOutList
      //     console.log(this.fromData)
      // }
      this.isLoading = false;
    },

    //保存提交数据
    async onSubSave() {
      this.$refs.bomList.onSubmitSaves()
      let vm = this;
        // if (!this.fromData.factoryStr) {
        //   this.$message.error("请选择工厂");
        //   return false;
        // }
        // if (!this.fromData.inventoryId) {
        //   this.$message.error("请选择库存地点");
        //   return false;
        // }
        // if (!this.fromData.orderType) {
        //   this.$message.error("请选择订单类型");
        //   return false;
        // }
        // if (!this.fromData.materialCode) {
        //   this.$message.error("请选择物料编码");
        //   return false;
        // }
        // if (!this.fromData.materialDesc) {
        //   this.$message.error("请选择物料描述");
        //   return false;
        // }
        // if (!this.fromData.optionBom) {
        //   this.$message.error("请选择BOM版本");
        //   return false;
        // }
        // if (!this.fromData.orderStates) {
        //   this.$message.error("请选择订单状态");
        //   return false;
        // }
        // if (!this.fromData.orderQuantityTotal || !this.fromData.orderConfirmScrap || !this.fromData.batchCharacter || !this.fromData.deliveryQty || !this.fromData.nachl) {
        //   this.$message.error("请补全明细信息");
        //   return false;
        // }
        this.fromData = this.$store.state.cache.ProdOrderOutList;
        if(this.$refs.bomList.PurchOrderList.length == 0){ 
          this.$message.error('请勾选需要提交的部件明细！');
          return false;
        }
        this.fromData.details = this.$refs.bomList.PurchOrderList
        this.fromData.voucherDate = this.$moment(this.fromData.voucherDate).format("YYYY-MM-DD");
	      this.fromData.postingDate = this.$moment(this.fromData.postingDate).format("YYYY-MM-DD");
        console.log(this.fromData,"=====测试数据======");
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$post(prodOrderInput.out, this.fromData);
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        if (res.status) {
          console.log(res);

          this.$confirm(
            "物料凭证 " +
              res.data.materialVoucherCode +
              " 已产生",
            "提示",
            {
              confirmButtonText: "继续",
              cancelButtonText: "退出",
              type: "success"
            }
          )
            .then(() => {
              vm.fromData = {};
			        vm.$store.state.cache.ProdOrderOutList = {};
              vm.$router.push({ name: "business-production-productorder-checkout" });
              //清除部分缓存数据
              vm.clearCache();
            })
            .catch(() => {
              vm.$router.push({ name: "home" });
			        vm.fromData = {};
			        vm.$store.state.cache.ProdOrderOutList = {};
              //清除部分缓存数据
              vm.clearCache();
            });
        } else {
          this.$message.error(res.errorMsg);
        }
    },
  }
};
</script>

<style lang="stylus" scoped></style>
